module.exports = __webpack_public_path__ + "static/media/CHAP03-ENCADRE-DERKAZ.656103a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP03-ENCADRE-DERKAZ.png
// module id = 284
// module chunks = 0